import { SEND_LOG, SendLogResponse } from 'src/configs/APISchemas/ErrorLog';
import { GraphQLRequest } from './GraphQLRequest';

export async function logToBackend(errorMessage: string, errorDetails?: string): Promise<void> {
  const details = errorDetails || errorMessage;

  try {
    await GraphQLRequest<SendLogResponse>(SEND_LOG, {
      message: errorMessage.toString(),
      jsonStringifiedString: JSON.stringify(details),
      pageUrl: window.location.origin + window.location.pathname,
    });
  } catch (error: any) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}
